import styled from 'styled-components';

export const StyledLocalVideoPreview = styled.div`
  box-shadow: var(--box-shadow) var(--color-shadow);
`;
